import button1 from '/public/siteImages/iOSTheme/buttonType/button1.png';
import button2 from '/public/siteImages/iOSTheme/buttonType/button2.png';
import button3 from '/public/siteImages/iOSTheme/buttonType/button3.png';
import button4 from '/public/siteImages/iOSTheme/buttonType/button4.png';

export {
    button1,
    button2,
    button3,
    button4,
}
